import { MergedProperty } from '../../types';

interface TextBoxItemProps {
    item: MergedProperty;
    colClass: string;
    dataType: string;
    onChange: (value: string, code: string) => void;
}

const TextBoxItem = ({ item, colClass, dataType, onChange }: TextBoxItemProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (dataType === 'number' && e.target.type !== dataType) {
            e.preventDefault();
            return;
        }
        onChange(e.target.value, item.ps_code);
    };

    return (
        <div className={`${colClass} col-sm-6`}>
            <div className="form-group">
                <label>
                    <h6 className="panel-title">{item.p_name}</h6>
                </label>
                <input
                    value={item.ps_value ?? ''}
                    className="form-control"
                    onChange={handleChange}
                    type={dataType}
                />
                <div className="contain-error" />
            </div>
        </div>
    );
};

export default TextBoxItem;
